import React from 'react';
import { Text } from 'components/typography/Text';
import styles from './styles.module.scss';

export const SmallOverlay = ({ intl }) => (
  <div className={styles.smallOverlay}>
    <Text
      white
      bold
      element="h4"
      size={10}
      intl={intl}
    />
  </div>
);
